import { render, staticRenderFns } from "./ContactStatsPage.vue?vue&type=template&id=5d882a69&"
import script from "./ContactStatsPage.vue?vue&type=script&lang=js&"
export * from "./ContactStatsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactStatsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports